import React from "react";
import { Group } from "@domain/group/group";
import { AboutShareroomDraftField } from "@domain/group/shareroom/shareroom";
import { IsOkIcon } from "@ui/components/icons";

interface ShareroomBlocAboutValidatorProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
	field: AboutShareroomDraftField;
}

export const ShareroomBlocAboutValidator: React.FC<ShareroomBlocAboutValidatorProps> = ({ shareroom, field }) => {
	return <IsOkIcon isValid={shareroom[field]?.hasText()} />;
};
